import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import Routes from '~/routes';
import { sendGTMEvent } from '~/utils';
import FavoritesSync from '~/components/FavoritesSync';

function App() {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_MEASUREMENT_ID ?? '',
  };
  const { data: responseData } = useGetUserQuery();

  useEffect(() => {
    TagManager.initialize(tagManagerArgs);
  }, []);

  useEffect(() => {
    responseData?.user?.id &&
      sendGTMEvent({
        event: 'gtm-user_session-started',
        userId: responseData?.user?.id.toString() ?? '',
      });
  }, [responseData?.user?.id]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get('access_token');
    const refreshToken = urlParams.get('refresh_token');

    if (accessToken) {
      document.cookie = `access_token=${accessToken}; path=/`;
      document.cookie = `refresh_token=${refreshToken}; path=/`;
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  return (
    <>
      <FavoritesSync />
      <Routes />
    </>
  );
}

export default App;
